export function tiempoTranscurrido(desdeFecha, hastaFecha) {
  const unMinutoEnMs = 60 * 1000; // un minuto en milisegundos
  const unaHoraEnMs = 60 * unMinutoEnMs; // una hora en milisegundos
  const unDiaEnMs = 24 * unaHoraEnMs; // un día en milisegundos

  const fechaDesde = new Date(desdeFecha);
  const fechaHasta = new Date(hastaFecha);

  const diferenciaMs = fechaHasta - fechaDesde;

  if (diferenciaMs < unMinutoEnMs) {
    const diferenciaSegundos = Math.floor(diferenciaMs / 1000);
    return `hace ${diferenciaSegundos} segundos`;
  } else if (diferenciaMs < unaHoraEnMs) {
    const diferenciaMinutos = Math.floor(diferenciaMs / unMinutoEnMs);
    return `hace ${diferenciaMinutos} minutos`;
  } else if (diferenciaMs < unDiaEnMs) {
    const diferenciaHoras = Math.floor(diferenciaMs / unaHoraEnMs);
    return `hace ${diferenciaHoras} horas`;
  } else {
    const diferenciaDias = Math.round(diferenciaMs / unDiaEnMs);
    const diferenciaSemanas = Math.round(diferenciaDias / 7);
    const diferenciaMeses = Math.round(diferenciaDias / 30);

    if (diferenciaDias === 1) {
      return "hace 1 día";
    } else if (diferenciaDias <= 7) {
      return `hace ${diferenciaDias} días`;
    } else if (diferenciaSemanas === 1) {
      return "hace 1 semana";
    } else if (diferenciaSemanas <= 4) {
      return `hace ${diferenciaSemanas} semanas`;
    } else if (diferenciaMeses === 1) {
      return "hace 1 mes";
    } else {
      return `hace ${diferenciaMeses} meses`;
    }
  }
}
